var React = require('react');

function BackIconBig (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.006 22.843c-.598.63-1.6.63-2.199 0L4.5 12 14.807 1.157a1.517 1.517 0 0 1 2.2 2.09L8.686 12l8.32 8.753a1.517 1.517 0 0 1 0 2.09z","fill":"#fff"}));
}

BackIconBig.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = BackIconBig;

BackIconBig.default = BackIconBig;
